module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-212.779b279c.svg";